import { render } from "./PromocionEdit.vue?vue&type=template&id=4f3aba3a"
import script from "./PromocionEdit.vue?vue&type=script&lang=js"
export * from "./PromocionEdit.vue?vue&type=script&lang=js"

import "./PromocionEdit.vue?vue&type=style&index=0&id=4f3aba3a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__